import { wrapUseRoutes } from '@sentry/react';
import { useRoutes as useRoutesRR } from 'react-router';

export const useRoutes = wrapUseRoutes(useRoutesRR);
